export default "__VITE_ASSET__1X78QCWH__"